export enum NOTIFICATION {
	INFO = "info",
	SUCCESS = "success",
	WARN = "warn",
	ERROR = "error"
}
